import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { setAddJuristdictionOpen, setJurisdictions, setSelectedState } from '../../../redux/slices/wikiSlice';

const AddJurisdiction = () => {
  const dispatch = useDispatch();
  const [showButton, setShowButton] = useState<boolean>(false);
  // @ts-ignore
  const { wikiId } = useParams();

  useEffect(() => {
    if (wikiId) {
      setShowButton(false);
      return;
    }
    setShowButton(true);
  }, [wikiId]);
  return (
    <Wrapper>
      <RowWrapper>
        {showButton && (
          <Button1>
            <Button color="primary" variant="contained" onClick={() => dispatch(setAddJuristdictionOpen(true))}>
              Add Jurisdiction
            </Button>
          </Button1>
        )}
      </RowWrapper>
    </Wrapper>
  );
};

export default AddJurisdiction;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const RowWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin: 0 0 16px;
`;

const Button1 = styled.div`
  button {
    min-width: 180px;
    height: 40px;
    border-radius: 8px;
    font-weight: 600;
    text-transform: none;
    letter-spacing: 0.01em;
  }
`;
